import React from "react";
import "./VertNavbar.css";
import "./ClubSettingsNavbar.css";
import { MainContext } from "../../contexts/MainContext";

import ClubSettingsNavbarElement from "./elements/ClubSettingsNavbarElement";
import BranchSelectorNavbarElement from "./elements/BranchSelectorNavbarElement";
import LogoNavbarElement from "./elements/LogoNavbarElement";
import UserNavbarElement from "./elements/UserNavbarElement";
import { Link } from "react-router-dom";

export default class ClubSettingsNavbar extends React.Component<
  {
    selectedScreen: string;
    clubId: string;
    branchArr: Array<any>;
    showMobile?: boolean;
    hideMobileNav: any;
    selectedBranch: string;
    onCreateBranch: any;
  },
  {}
> {
  static contextType = MainContext;
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div
          className={`nav-background ${
            this.props.showMobile && " show-nav-background"
          }`}
          onClick={this.props.hideMobileNav}
        ></div>
        <nav
          className={`vert-navbar br-navbar ${
            this.props.showMobile && " vert-navbar-mobile"
          }`}
        >
          <LogoNavbarElement />
          <div className="vert-navbar-scrollable">
            <UserNavbarElement to={`/club/${this.props.clubId}/profile`} />
            <ClubSettingsNavbarElement
              title="Aussehen"
              iconPrefix="fas"
              iconName="palette"
              selected={this.props.selectedScreen === "appearance"}
              onClick={this.props.hideMobileNav}
              linkTo={`/club-settings/${this.props.clubId}/appearance`}
            />
            <ClubSettingsNavbarElement
              title="Benutzer"
              iconPrefix="fas"
              iconName="users"
              selected={this.props.selectedScreen === "users"}
              onClick={this.props.hideMobileNav}
              linkTo={`/club-settings/${this.props.clubId}/users`}
            />
            <ClubSettingsNavbarElement
              title="Bereiche"
              iconPrefix="fas"
              iconName="code-branch"
              selected={this.props.selectedScreen === "branches"}
              onClick={this.props.hideMobileNav}
              linkTo={`/club-settings/${this.props.clubId}/branches/${
                this.props.branchArr.length > 0
                  ? this.props.branchArr[0].id
                  : ""
              }`}
            />
            <div
              className={`navbar-objects ${
                this.props.selectedScreen === "branches" &&
                "navbar-objects-selected"
              }`}
            >
              {this.props.branchArr.map((object: any) => (
                <BranchSelectorNavbarElement
                  title={object.name}
                  selected={this.props.selectedBranch === object.id}
                  onClick={this.props.hideMobileNav}
                  linkTo={`/club-settings/${this.props.clubId}/branches/${object.id}`}
                  key={object.id}
                />
              ))}
              {this.context.isAdmin && (
                <div
                  className={"navbar-element navbar-create-element"}
                  onClick={this.props.onCreateBranch}
                >
                  <span>+</span>
                </div>
              )}
            </div>
            <ClubSettingsNavbarElement
              title="Einstellungen"
              iconPrefix="fas"
              iconName="cog"
              selected={this.props.selectedScreen === "settings"}
              onClick={this.props.hideMobileNav}
              linkTo={`/club-settings/${this.props.clubId}/settings`}
            />
          </div>
          <Link
            to={`/club/${this.props.clubId}`}
            className={"navbar-element navbar-back-element"}
            onClick={this.props.hideMobileNav}
          >
            zum System
          </Link>
        </nav>
      </>
    );
  }
}
